<template>
    <v-container fluid>
        <v-row>
            <productsStock></productsStock>
        </v-row>
        <v-row>
            <v-col>
                <TableOrdersB2B></TableOrdersB2B>
            </v-col>
            <v-col>
                <TableServiceCenter></TableServiceCenter>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import TableOrdersB2B from "./Widgets/TableOrdersB2B";
    import PendingOrders from "./Widgets/PendingOrders";
    import TableServiceCenter from "./Widgets/TableServiceCenter";
    import ProductsStock from "./Widgets/ProductsStock";

    export default {
        components: {
            ProductsStock,
            TableServiceCenter,
            TableOrdersB2B,
            PendingOrders,
        },
        computed: {
            profile() {
                return User.getters.getProfileId
            }
        }
    }
</script>
